
import copy from '@/utils/deepCopy'
import print from '@/utils/deepCopy'

export default {
  data() {
    return {
      dialogVisible: false, // 对话框
      index: 0,
      // 选中的城市
      checkedCities: {
        0: [],
        1: [],
        2: [],
        3: [],
        4: [],
        5: [],
        6: [],
      },
      // 查看是否选中整个区域(区域全选)
      selectedAllCities: {
        0: false,
        1: false,
        2: false,
        3: false,
        4: false,
        5: false,
        6: false,
      },
      // 规则
      rules: {
        templeName: [
          { required: true, message: "请输入模板名称", trigger: "blur" },
          {
            min: 1,
            max: 20,
            message: "长度在 1 到 20 个字符",
            trigger: "blur",
          },
        ],
        chargeType: [
          { required: true, message: "请选择计费方式", trigger: "change" },
        ],
      },
      cities: [],
    }
  },
  methods: {
    // 修改区域
    modify(index) {
      this.dialogVisible = true;
      this.index = index;
      let items = this.regions[index].citys;
      for (let i = 0; i < this.cities.length; i++) {
        this.checkedCities[i] = [];
        for (let m = 0; m < items.length; m++) {
          for (let j in this.cities[i].data) {
            if (this.cities[i].data[j].id == items[m]) {
              this.checkedCities[i].push(items[m]); // id匹配
            }
            // Object.keys(this.cities[i].data[j]).map((k) => {
            //   if (this.cities[i].data[j][k].id == items[m]) {
            //     this.checkedCities[i].push(items[m]); // id匹配
            //   }
            // });
          }
        }
        this.selectedAllCities[i] =
          this.checkedCities[i].length === this.cities[i].data.length;
      }
    },
    // 设置省份选择模板的数据
    setCities(res) {
      let area = [];
      let obj = {};
      // 匹配区域
      area = res.reduce((pre, cur) => {
        if (obj[cur.regionName]) {
          let index = pre.findIndex((e) => e.regionId == cur.regionId);
          pre[index].data.push(cur);
        } else {
          obj[cur.regionName] = true;
          pre.push({
            regionName: cur.regionName,
            regionId: cur.regionId,
            data: [cur],
          });
        }
        return pre;
      }, []);
      this.cities = area;
      // 清空选中项
      for (const key in this.checkedCities) {
        this.checkedCities[key] = [];
      }
      Object.keys(this.selectedAllCities).map((e) => {
        this.selectedAllCities[e] = false;
      });
    },
    // 添加区域模板
    addModel() {
      this.regions.push({
        citysName: [],
        citys: [],
        firstValue: "",
        firstFee: "",
        continueValue: "",
        continueFee: ""
      });
    },
    // 删除配送区域
    handleDelete(index) {
      this.regions.splice(index, 1);
    },
    // 查看是否全选
    handleCheckedCitiesChange(event, index) {
      this.selectedAllCities[index] =
        event.length === this.cities[index].data.length;
    },
    // 全选
    selectAll(event, index) {
      this.checkedCities[index] = event
        ? this.cities[index].data.map((m) => m.id)
        : [];
      this.selectedAllCities[index] = event;
    },
    // 确认选中区域
    confirmRegion() {
      this.regions[this.index].citys = []; // 先清空，再添加
      this.regions[this.index].citysName = [];
      for (const i in this.checkedCities) {
        this.regions[this.index].citys.push(...this.checkedCities[i])
      }
      this.provinces.map((m) => {
        this.regions[this.index].citys.map((e) => {
          if (m.id == e) {
            this.regions[this.index].citysName.push(m);
          }
        });
      });
      this.dialogVisible = false;
    },
  },
}

